<template>
  <div
    class="product-card__cart-btn btn primary"
    :class="{'outlined': inCart}"
    @click="addToCartHandler"
  >
    {{ buttonTitle }}
  </div>
</template>

<script setup lang="ts">
import useCart from '#sitis/composables/useSitisCart';
import type { IProduct } from '#sitis/internal/controllers/products/models/Product';
import type { IAddItemToCartBody } from '#sitis/internal/controllers/cart/models/CartItem';
import type { IExtendedProductOptionsVariant } from '~/pages/product/[...slug].vue';
import useEcommerce from '~/composables/useEcommerceYandex';
import {useCustomNotificationStore} from "~/store/customNotification";

const { addEcommerce } = useEcommerce();
const { product, selectedOptionsList = [] } = defineProps<{
  product: IProduct;
	selectedOptionsList?:IExtendedProductOptionsVariant[];
}>();
const { $ym } = useNuxtApp();
const emit = defineEmits<{
	checkOptionsErrors:[isHasError:boolean]
}>();

const {
  openCustomNotification,
} = useCustomNotificationStore();

const openPopupCustomNotification = function() {
  openCustomNotification({
    title: 'Корзина',
    message: 'Ваш товар был добавлен в корзину'
  });
}

const {
  itemsCart,

  addToCart,
  removeItem,
  getCart
} = useCart();

const isHasError = computed(() => !(product.options?.length === selectedOptionsList?.length));

// Проверка на наличие товара в заказе
const inCart = computed((): boolean => {
  if (product.id) {
    const productFromCart = itemsCart.value.find((item) => item.product.id === product.id);
    return !!(productFromCart && productFromCart.quantity >= 1);
  }

  return false;
});

const addToCartHandler = async ():Promise<void> => {
  if (product.options && isHasError.value && !inCart.value) {
    emit('checkOptionsErrors', isHasError.value);
    return;
  }

  if (product.options && !isHasError.value && !inCart.value) {
    emit('checkOptionsErrors', isHasError.value);
  }

  if (!product.id) {
    return;
  }

  // раскомментировать, если хотим, чтобы на 2-е нажатие кнопки товар удалялся из корзины
  // if (inCart.value) {
  //   await removeItemFromCart();
  // }
  else {
    await putToCart();
    openPopupCustomNotification();
  }
};
const putToCart = async () => {
  const body: IAddItemToCartBody = {
    productId: Number(product.id),
    quantity: 1
  };

  if (product.options) {
    body.options = setBodyForCart();
  }

  const response = await addToCart(body).then((res) => res);
  if (typeof $ym === 'function') {
    $ym('reachGoal', 'addToCart');
  }

  addEcommerce('add', product, { quantity: 1 });
  if (response) {
    await getCart();
  }
};
const removeItemFromCart = async () => {
  const productFromCart = itemsCart.value.find((t) => t?.product?.id === product.id);
  await removeItem(String(productFromCart?.id));
  addEcommerce('remove', product, { quantity: 1 });
};
const setBodyForCart = () => {
  const resObj:{[key:string]:number []} = {};

  if (selectedOptionsList) {
    selectedOptionsList.forEach((t) => {
      resObj[t.productOptionId] = [t.id];
    });
  }

  return resObj;
};
const buttonTitle = computed(() => {
  // раскомментировать, если хотим после добавления изменять надпись в кнопке
 // return inCart.value ? 'Добавлен' : 'Добавить в корзину'
  return 'Добавить в корзину'
})
</script>

<style scoped lang="scss">
.product-card__cart-btn{
  border: 3px solid;
  padding: 0 32px;
  height: 55px;
  font-size: 19px;
  line-height: 31px;
}

@media ( max-width:1200px) {
  .product-card__cart-btn {

  }
}

@media ( max-width: 1024px) {
  .product-card__cart-btn {
    height: 40px;
  }
}

@media ( max-width: 640px) {
  .product-card__cart-btn {
    padding: 0 10px;
    font-size: 16px;
    border-width: 2px;
    border-radius: 3px;
    font-weight: 400;
  }
}
</style>
